import { BookingStep } from '@/features/booking'
import { translate } from '@/utils/translator'

import { LocationContent } from './locationContent'
import { LocationSummary } from './locationSummary'

export const LocationStep = () => {
	return (
		<BookingStep
			number="01"
			title={translate('step-01-title')}
			instructions={translate('step-01-instructions')}
			step="LOCATION"
			summary={<LocationSummary />}
		>
			<LocationContent />
		</BookingStep>
	)
}
